module.exports = __webpack_public_path__ + "static/media/boy-19.f81418ab.svg";